import React from "react";
import { I18n } from "react-redux-i18n";
import cx from "classnames";

import { Flex } from "@common/components/Flex";
import { Loading } from "@common/components/loading";
import { getTestAttributes } from "@common/utils/tests";

import { FormatColumnKey, FormatsProps } from "./formats.types";
import { FormatFieldItem } from "../../format-field-selector.types";

import "./formats.styles.scss";

export function Formats<T extends FormatFieldItem>(props: FormatsProps<T>) {
  const {
    formats,
    selectedFormat,
    loading,
    onSelectedFormatChange,
    className,
    classes,
    moduleName,
  } = props;

  const tableColumnsConfig: Array<{ label: string; field: FormatColumnKey }> =
    React.useMemo(
      () => [
        {
          label: I18n.t("Format Name"),
          field: FormatColumnKey.name,
        },
        { label: I18n.t("Description"), field: FormatColumnKey.description },
      ],
      []
    );

  return (
    <div className={cx("FormatFieldSelectorFormats", className)}>
      <div className="FormatFieldSelectorFormats__table">
        <Flex
          className="FormatFieldSelectorFormats__table__header"
          width="100%"
          justify="space-between"
          {...getTestAttributes({
            id: moduleName
              ? `${moduleName}-format-field-selector-formats-table-header`
              : "ss-format-grid-thead-row0",
          })}
        >
          {tableColumnsConfig.map(({ field, label }, colIndex) => (
            <div
              {...getTestAttributes({
                id: moduleName
                  ? `${moduleName}-format-field-selector-formats-table-header-cell-${colIndex}`
                  : `ss-format-grid-thead-row0-cell${colIndex}`,
              })}
              className="FormatFieldSelectorFormats__table__header__cell"
              style={{ width: `${100 / tableColumnsConfig.length}%` }}
              key={field}
            >
              {label}
            </div>
          ))}
        </Flex>
        <div
          className={cx(
            "FormatFieldSelectorFormats__table__body",
            classes?.tableBody
          )}
        >
          {loading && <Loading size={20} margin="20px" />}
          {!loading && !formats.length && (
            <div className="FormatFieldSelectorFormats__table__body__no-data-message">
              {I18n.t("No data")}
            </div>
          )}
          {!loading &&
            formats.length > 0 &&
            formats.map((item, rowIndex) => (
              <Flex
                key={item.id}
                {...getTestAttributes({
                  id: moduleName
                    ? `${moduleName}-format-field-selector-formats-table-body-row-${rowIndex}`
                    : `ss-format-grid-tbody-row${rowIndex}`,
                })}
                width="100%"
                justify="space-between"
                className={cx("FormatFieldSelectorFormats__table__body__row", {
                  "FormatFieldSelectorFormats__table__body__row--selected":
                    item.id === selectedFormat?.id,
                })}
                onClick={() => onSelectedFormatChange(item)}
              >
                {tableColumnsConfig.map(({ field }, colIndex) => (
                  <div
                    style={{ width: `${100 / tableColumnsConfig.length}%` }}
                    key={field}
                    {...getTestAttributes({
                      id: moduleName
                        ? `${moduleName}-format-field-selector-formats-table-body-row-${rowIndex}-cell-${colIndex}`
                        : `ss-format-grid-tbody-row${rowIndex}-cell${colIndex}`,
                    })}
                    className="FormatFieldSelectorFormats__table__body__row__cell"
                  >
                    {/* TODO: Get img src from format */}
                    {field === FormatColumnKey.name && (
                      <img
                        className="FormatFieldSelectorFormats__table__body__row__cell__icon"
                        src="gif/ss_individual.gif"
                        alt={item[field]}
                      />
                    )}
                    {item[field]}
                  </div>
                ))}
              </Flex>
            ))}
        </div>
      </div>
    </div>
  );
}
